module.exports = __webpack_public_path__ + "static/img/circular-arrow.96a2364e.png";